import { render, staticRenderFns } from "./RsaConfigurazioneTipoImpegnativaListComponent.vue?vue&type=template&id=66fd5ef4"
import script from "./RsaConfigurazioneTipoImpegnativaListComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneTipoImpegnativaListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports